(function () {
  /**
   * Service to help with converting snake case received in JSON responses to camel case.
   */
  angular.module('core').factory('edxSnakeToCamelService', [Factory]);

  function Factory() {
    var lodash = _;

    SnakeToCamelService.prototype.snakeToCamel = snakeToCamel;
    return new SnakeToCamelService();

    function SnakeToCamelService() {
      if (lodash === null) {
        throw new Error('This service requires lodash');
      }
    }

    /**
     * Change object key names from snake case to camel case
     * 
     * @param el The object ot be modified
     * @param recurse True to recurse into child objects
     * @return {*}
     */
    function snakeToCamel(el, recurse) {
      if (angular.isArray(el)) {
        el.forEach(function(item){
          snakeToCamel(item, recurse);
        });
      } else if (angular.isObject(el)) {
        var keysToCamelCase = {};
        var key, ckey;
        for (key in el) {
          if (el.hasOwnProperty(key)) {

            if (recurse) {
              el[key] = snakeToCamel(el[key], recurse);
            }

            ckey = lodash.camelCase(key);
            if (ckey.toLowerCase() !== key.toLowerCase()) {
              keysToCamelCase[key] = el[key];
            }
          }
        }
        for (key in keysToCamelCase) {
          if (keysToCamelCase.hasOwnProperty(key)) { // make jslint happy
            ckey = lodash.camelCase(key);
            delete el[key];
            el[ckey] = keysToCamelCase[key];
          }
        }
      }
      return el;
    }
  }
})();